// extracted by mini-css-extract-plugin
export var disclaimer = "WhySilverseaSection-module--disclaimer--a8aee";
export var list = "WhySilverseaSection-module--list--28d29";